// IndexedDB tabanlı offline önbellek: ürün kataloğu + ayarlar. Ek bağımlılık yok.
// Amaç: internet kesildiğinde kasada barkod okuma + ürün arama + fiyat gösterimi devam etsin.
const DB = "groot_offline";
const STORE = "kv";
let _dbp = null;

function db() {
  if (_dbp) return _dbp;
  _dbp = new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") return reject(new Error("no-indexeddb"));
    const r = indexedDB.open(DB, 1);
    r.onupgradeneeded = () => { if (!r.result.objectStoreNames.contains(STORE)) r.result.createObjectStore(STORE); };
    r.onsuccess = () => resolve(r.result);
    r.onerror = () => reject(r.error);
  });
  return _dbp;
}

async function idbSet(key, val) {
  try {
    const d = await db();
    return await new Promise((res, rej) => {
      const tx = d.transaction(STORE, "readwrite");
      tx.objectStore(STORE).put(val, key);
      tx.oncomplete = () => res(true);
      tx.onerror = () => rej(tx.error);
    });
  } catch { return false; }
}

async function idbGet(key) {
  try {
    const d = await db();
    return await new Promise((res) => {
      const tx = d.transaction(STORE, "readonly");
      const rq = tx.objectStore(STORE).get(key);
      rq.onsuccess = () => res(rq.result);
      rq.onerror = () => res(undefined);
    });
  } catch { return undefined; }
}

export const cacheCatalog = (channel, items) => idbSet(`catalog:${channel}`, { at: Date.now(), items: items || [] });
export const getCachedCatalog = async (channel) => (await idbGet(`catalog:${channel}`)) || null;
export const cacheKV = (key, val) => idbSet(`kv:${key}`, { at: Date.now(), val });
export const getCachedKV = async (key) => { const v = await idbGet(`kv:${key}`); return v ? v.val : undefined; };

export function filterCatalog(items, q, opts = {}) {
  const s = (q || "").trim().toLowerCase();
  let list = items || [];
  if (s) {
    list = list.filter((p) =>
      (p.name || "").toLowerCase().includes(s) ||
      (p.sku || "").toLowerCase().includes(s) ||
      (p.legacy_stock_code || "").toLowerCase().includes(s) ||
      (p.barcode || "").toLowerCase().includes(s) ||
      (p.barcodes || []).some((b) => String(b).toLowerCase().includes(s)));
  }
  return list.slice(0, opts.limit || 60);
}

export function findByBarcode(items, code) {
  const c = String(code || "").trim();
  if (!c) return null;
  return (items || []).find((p) => p.barcode === c || (p.barcodes || []).map(String).includes(c)) || null;
}
